import React from 'react'

const MenuIcon = ({ header, title, onClick, children, color }) => {
    return (
        <div
            style={{
                    float           : 'left', 
                    width           : '220px', 
                    cursor          : 'pointer', 
                    border          : '1px solid', 
                    borderColor     : color || '#305496',
                    backgroundColor : '#fff', 
                    margin          : '8px', 
                    padding         : '15px', 
                    borderRadius    : '10px'
                }}
            onClick={onClick}>
            <div style={{ color: color || '#305496', fontSize:'14px' }}>{ header }</div>
                {children}
            <div style={{ fontWeight:'bold', color: color || '#305496', fontSize:'18px' }}>{ title }</div>
        </div>
    )
  }
  
  export default MenuIcon
